import {Box, HStack} from 'platform/foundation-tw';

import {Children, isValidElement, type ReactNode} from 'react';

interface WithSidebarLayoutProps {
  readonly children: ReactNode;
}

interface SidebarProps {
  readonly children: ReactNode;
}

interface ContentProps {
  readonly children: ReactNode;
}

const SIDEBAR_DISPLAY_NAME = 'WithSidebarLayout.Sidebar';
const CONTENT_DISPLAY_NAME = 'WithSidebarLayout.Content';

function SidebarComponent(props: SidebarProps) {
  return (
    <div className="w-80 shrink-0">
      <div className="sticky top-2 max-h-[calc(100dvh-1rem)] overflow-y-auto py-8 pl-8">
        {props.children}
      </div>
    </div>
  );
}

SidebarComponent.displayName = SIDEBAR_DISPLAY_NAME;

function ContentComponent(props: ContentProps) {
  return (
    <Box position="relative" flexGrow={1}>
      {props.children}
    </Box>
  );
}

ContentComponent.displayName = CONTENT_DISPLAY_NAME;

export const WithSidebarLayout = (props: WithSidebarLayoutProps) => {
  let sidebar: ReactNode = null;
  let content: ReactNode = null;

  Children.forEach(props.children, (child) => {
    if (!isValidElement(child)) {
      return;
    }

    const displayName = (child.type as {displayName?: string})?.displayName;

    if (displayName === SIDEBAR_DISPLAY_NAME) {
      sidebar = child;
    } else if (displayName === CONTENT_DISPLAY_NAME) {
      content = child;
    }
  });

  return (
    <Box width="100%" backgroundColor="general.white" borderRadius="large">
      <HStack spacing={0} align="stretch" width="100%">
        {sidebar}
        <div className="w-px self-stretch bg-[var(--color-mira-gray-10)]" />
        {content}
      </HStack>
    </Box>
  );
};

WithSidebarLayout.Sidebar = SidebarComponent;
WithSidebarLayout.Content = ContentComponent;
